// SplashScreen.js
import React from 'react';
import '../index.css';

const Splash = ({ onStart }) => {
  return (
    <div className="splash-screen">
      <div className="splash-content">
        <div className="splash-logo">
          <svg width="80" height="80" viewBox="0 0 100 100" fill="none">
            <circle cx="50" cy="50" r="45" stroke="#e2b9b3" strokeWidth="4"/>
            <path d="M35 40L45 55L65 30" stroke="#e2b9b3" strokeWidth="4" strokeLinecap="round"/>
            <path d="M50 25V35" stroke="#e2b9b3" strokeWidth="4" strokeLinecap="round"/>
            <path d="M50 65V75" stroke="#e2b9b3" strokeWidth="4" strokeLinecap="round"/>
            <path d="M25 50H35" stroke="#e2b9b3" strokeWidth="4" strokeLinecap="round"/>
            <path d="M65 50H75" stroke="#e2b9b3" strokeWidth="4" strokeLinecap="round"/>
          </svg>
        </div>
        <h1>Staff Feedback Survey</h1>
        <p>Your voice matters in shaping our workplace</p>
        <div className="d-flex justify-content-center my-4">
          <div>
            <div className="feature-item d-flex align-items-center mb-2">
              <span className="feature-icon me-2">✓</span>
              <span>Completely anonymous</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <span className="feature-icon me-2">✓</span>
              <span>Takes about 10 minutes</span>
            </div>
            <div className="feature-item d-flex align-items-center">
              <span className="feature-icon me-2">✓</span>
              <span>Helps us improve together</span>
            </div>
          </div>
        </div>

        <button className="start-button" onClick={onStart}>
          Begin Survey
        </button>
      </div>
    </div>
  );
};

export default Splash;